import React from 'react';
import {
    Grid,
    TextField,
    IconButton,
    Box,
    Tooltip,
    Popover,
    Typography,
    InputLabel,
    Select,
    MenuItem,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear'
import FormControl from '@material-ui/core/FormControl';
import { KeyboardDatePicker } from '@material-ui/pickers';
import CloseIcon from '@material-ui/icons/Close';
import {
    globalDateEntity,
} from '../../constants/applicationConstants';

const useStyles = makeStyles({
    filterIconPopover: {
        border: '2px solid #A9A9A9', 
        borderRadius: '15px 0px 15px 15px'
    },
    filterOptionsBox: {
        padding: '20px', 
        background: '#EDEDED', 
        minWidth: '500px'
    },
    btnCloseFiltersPopover: {
        display:'flex', 
        justifyContent: 'flex-end', 
        paddingTop: '0', 
        paddingRight: '0'
    },
    paginationBox: {
        margin: '30px 0'
    }
}); 


const ImportFilterSection = ({statusFilter, anchorEl, keywordsFilter, isPAChecked, handlePAFilter, handleKeywordsChange, handleStatusToggle, handleFilterIconClick, handleCloseFilterBox, setKeywordsFilter, handlingOptions, handlingLabel, recordTypesFilterLabel, recordTypesFilterOptions, handleTypesFilterChange, recordTypeFilter, setRecordTypeFilter, textApproved, textDraft, keywordsPlaceholder, fromDateFilter, setFromDateFilter, toDateFilter, setToDateFilter, importTypeFilter, handleImportTypeFilter, importStatusFilter, handleImportStatusFilter, importTypes, setFiltersApplied, resetFilters}) => {

    const classes = useStyles();

    const importStatusList = [
        {"key": "COMPLETED", "value": "Completed"},
        {"key": "PREVIEW", "value": "Preview"},
        {"key": "PROCESSING", "value": "Processing"},
        {"key": "QUEUED", "value": "Queued"}
    ]

    // For filter box popover
    const openFilterBox = Boolean(anchorEl);
    const idPopover = openFilterBox ? 'simple-popover' : undefined;

    function clearFilters() {

        if (typeof setKeywordsFilter !== "undefined") { 
            setKeywordsFilter("")
        }

        if (typeof setFromDateFilter !== "undefined") { 
            setFromDateFilter("")
        }

        if (typeof setToDateFilter !== "undefined") { 
            setToDateFilter("")
        }

        if (typeof resetFilters !== "undefined") { 
            resetFilters("")
        }
        
      }

    return (
        <Grid item md={4}  alignItems='center' justifyContent='center' style={{display: 'flex'}}>
            <FormControl  variant="filled">
                <TextField 
                    id="SearchInput"
                    name="SearchInput"
                    type='text'
                    variant="outlined"
                    size="small"
                    placeholder={keywordsPlaceholder}
                    value={keywordsFilter}
                    onChange={handleKeywordsChange}
                    autoComplete="off"
                    InputProps={{
                        endAdornment: (
                            <>
                                {keywordsFilter && <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={(e) => setKeywordsFilter("")}
                                ><ClearIcon style={{ fontSize: 18 }} /></IconButton>}
                                <InputAdornment position="end">
                                    <SearchIcon />
                                </InputAdornment>
                            </>
                        ),
                        style: {
                            color: '#9D9D9D'
                        }
                    }}
                    style={{minWidth: '350px'}}
                />
            </FormControl>

            <Box>
                <Tooltip title="Filter"><IconButton onClick={handleFilterIconClick}>
                    <svg xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24" height="25" viewBox="0 0 24 24" width="25" fill="#ADADAD"><g><path d="M0,0h24 M24,24H0" fill="none"/><path d="M4.25,5.61C6.27,8.2,10,13,10,13v6c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v-6c0,0,3.72-4.8,5.74-7.39 C20.25,4.95,19.78,4,18.95,4H5.04C4.21,4,3.74,4.95,4.25,5.61z"/><path d="M0,0h24v24H0V0z" fill="none"/></g></svg>
                </IconButton></Tooltip>
                <Popover 
                    id={idPopover}
                    open={openFilterBox}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    className={classes.filterIconPopover}
                    >

                        <Box className={classes.filterOptionsBox}>

                            <Grid container direction="column" spacing="1">
                                <Grid item className={classes.btnCloseFiltersPopover}>
                                    <Tooltip title="Clear Filters">
                                        <IconButton onClick={clearFilters}>
                                            <svg xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24"  viewBox="0 0 122.88 110.668" x="0px" y="0px" width="22px" height="22px" fill="#444444"><g><path fill-rule="evenodd" clip-rule="evenodd" d="M91.124,15.645c12.928,0,23.406,10.479,23.406,23.406 c0,12.927-10.479,23.406-23.406,23.406c-12.927,0-23.406-10.479-23.406-23.406C67.718,26.125,78.197,15.645,91.124,15.645 L91.124,15.645z M2.756,0h117.322c1.548,0,2.802,1.254,2.802,2.802c0,0.848-0.368,1.622-0.996,2.139l-10.667,13.556 c-1.405-1.375-2.95-2.607-4.614-3.672l6.628-9.22H9.43l37.975,46.171c0.59,0.516,0.958,1.254,0.958,2.102v49.148l21.056-9.623 V57.896c1.651,1.9,3.548,3.582,5.642,4.996v32.133c0,1.105-0.627,2.064-1.586,2.506l-26.476,12.758 c-1.327,0.773-3.023,0.332-3.798-1.033c-0.258-0.441-0.368-0.92-0.368-1.4V55.02L0.803,4.756c-1.07-1.106-1.07-2.839,0-3.945 C1.355,0.258,2.056,0,2.756,0L2.756,0z M96.93,28.282c1.328-1.349,3.489-1.355,4.825-0.013c1.335,1.342,1.341,3.524,0.013,4.872 l-5.829,5.914l5.836,5.919c1.317,1.338,1.299,3.506-0.04,4.843c-1.34,1.336-3.493,1.333-4.81-0.006l-5.797-5.878l-5.807,5.889 c-1.329,1.349-3.489,1.355-4.826,0.013c-1.335-1.342-1.341-3.523-0.013-4.872l5.83-5.913l-5.836-5.919 c-1.317-1.338-1.3-3.507,0.04-4.843c1.339-1.336,3.492-1.333,4.81,0.006l5.796,5.878L96.93,28.282L96.93,28.282z"/></g></svg>
                                        </IconButton>                                    
                                    </Tooltip>
                                    
                                    <Tooltip title="Close"><IconButton onClick={handleCloseFilterBox}><CloseIcon /></IconButton></Tooltip>
                                </Grid>
                                <Grid item>
                                    <Grid container alignItems='center'>
                                        <Grid item xs={5}>
                                            <Typography variant="h6" component="h6" className="filterFormLabel"><label>Keyword</label></Typography>
                                        </Grid>
                                        <Grid item xs={7}>
                                            <TextField type='text'
                                            variant="outlined"
                                            size="small"
                                            value={keywordsFilter}
                                            onChange={handleKeywordsChange}
                                            placeholder={keywordsPlaceholder} 
                                            fullWidth={true}
                                            autoComplete="off"
                                            InputProps={{
                                                endAdornment: (
                                                    <>
                                                        {keywordsFilter && <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={(e) => setKeywordsFilter("")}
                                                        ><ClearIcon style={{ fontSize: 18 }} /></IconButton>}
                                                    </>
                                                ),
                                                style: {
                                                    color: '#9D9D9D'
                                                }
                                            }}
                                            />
                                        </Grid>
                                    </Grid>                                                    
                                </Grid>
                                <Grid item>
                                    <Grid container alignItems='center' style={{marginTop: '20px'}} spacing={2}>
                                        <Grid item xs={6}>
                                            
                                            <KeyboardDatePicker
                                                style={{ marginBottom: '3%' }}
                                                label="From Date"
                                                size="small"
                                                format={globalDateEntity.datePickerFormat}
                                                autoOk
                                                variant="inline"
                                                inputVariant="outlined"
                                                // required
                                                name="fromDate"
                                                onChange={(e, value) => {
                                                    setFromDateFilter(value)
                                                    setFiltersApplied(true)
                                                }}
                                                value={fromDateFilter=='' ? new Date() : fromDateFilter}
                                                InputProps={{
                                                    startAdornment: (
                                                        <>
                                                            {fromDateFilter && <IconButton
                                                                aria-label="clear filter"
                                                                onClick={(e) => setFromDateFilter("")}
                                                            ><ClearIcon style={{ fontSize: 18 }} /></IconButton>}
                                                            <InputAdornment position="end">
                                                                <SearchIcon />
                                                            </InputAdornment>
                                                        </>
                                                    ),
                                                    style: {
                                                        color: '#9D9D9D'
                                                    }
                                                }}
                                            />
                                                
                                        </Grid>
                                        <Grid item xs={6}>
                                            <KeyboardDatePicker
                                                style={{ marginBottom: '3%' }}
                                                label="To Date"
                                                size="small"
                                                format={globalDateEntity.datePickerFormat}
                                                autoOk
                                                variant="inline"
                                                inputVariant="outlined"
                                                // required
                                                name="toDate"
                                                onChange={(e, value) => {
                                                    setToDateFilter(value)
                                                    setFiltersApplied(true)
                                                }}
                                                value={toDateFilter=='' ? new Date() : toDateFilter}
                                                InputProps={{
                                                    startAdornment: (
                                                        <>
                                                            {toDateFilter && <IconButton
                                                                aria-label="clear filter"
                                                                onClick={(e) => setToDateFilter("")}
                                                            ><ClearIcon style={{ fontSize: 18 }} /></IconButton>}
                                                            <InputAdornment position="end">
                                                                <SearchIcon />
                                                            </InputAdornment>
                                                        </>
                                                    ),
                                                    style: {
                                                        color: '#9D9D9D'
                                                    }
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                
                                <Grid item>
                                    <Grid container alignItems='center' style={{marginTop: '20px'}} spacing={2}>
                                        <Grid item xs={6}>
                                            <FormControl
                                                // required
                                                variant="outlined"
                                                fullWidth
                                            >
                                                <InputLabel id="demo-simple-select-outlined-label">
                                                    Import Type
                                                </InputLabel>
                                                <Select 
                                                    name="importType" 
                                                    placeholder="Type"
                                                    value={importTypeFilter}
                                                    onChange={handleImportTypeFilter}
                                                    style={{height: '50px',  marginBottom: '10px'}}
                                                    label="Import Type"
                                                >
                                                    <MenuItem value="all">
                                                        <em>All</em>
                                                    </MenuItem>
                                                    {importTypes &&
                                                    importTypes.map((value, index) => {
                                                        return (
                                                        <MenuItem key={index} value={value.title}>
                                                            {value.title}
                                                        </MenuItem>
                                                        );
                                                    })}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <FormControl
                                                // required
                                                variant="outlined"
                                                fullWidth
                                            >
                                                <InputLabel id="import-status-filter-label">
                                                    Status
                                                </InputLabel>
                                                <Select 
                                                    name="importStatusFilter" 
                                                    placeholder="Status"
                                                    value={importStatusFilter}
                                                    onChange={(e) => handleImportStatusFilter(e.target.value) }
                                                    style={{height: '50px',  marginBottom: '10px'}}
                                                    label="Status"
                                                >
                                                    <MenuItem value="all">
                                                        <em>All</em>
                                                    </MenuItem>
                                                    {importStatusList &&
                                                    importStatusList.map((item, index) => {
                                                        return (
                                                        <MenuItem key={index} value={item.key}>
                                                            {item.value}
                                                        </MenuItem>
                                                        );
                                                    })}           
                                                </Select>
                                            </FormControl>

                                        </Grid>
                                    </Grid>
                                </Grid>
                                
                            </Grid>
                        </Box>
                </Popover>
            </Box>
        </Grid>
    )
}

ImportFilterSection.defaultProps = {
    recordTypesFilterLabel: null,
    recordTypesFilterOptions: [],
    handlingLabel: null,
    handlingOptions: [],
    handleTypesFilterChange: function() {

    },
    textApproved: "Approved",
    textDraft: "Draft"
}

export default ImportFilterSection;